import styled from "styled-components";

export const StudiesLogo = styled.img`
  width: 9rem;
`
